/**
 * Route utilities for handling base URL and path construction
 */

import { resolveViteBaseUrl } from './viteBaseUrl';

/**
 * Get the base URL from environment
 * In tests, this will be mocked
 */
export const getBaseUrl = (): string => resolveViteBaseUrl() || '/';

/**
 * Build a full path with BASE_URL
 * @param path - The route path (e.g., '/login', 'home')
 * @returns Full path with BASE_URL prefix
 */
export const buildPath = (path: string): string => {
    const base = getBaseUrl();
    const baseWithoutSlash = base.endsWith('/') ? base.slice(0, -1) : base;
    const route = path.startsWith('/') ? path : `/${path}`;
    return `${baseWithoutSlash}${route}`;
};
